import type { BreadcrumbItemData } from '../Breadcrumb/Breadcrumb.types';
import { SparkIcon } from '../SparkIcon';

/** Full-size drawer container width as a viewport fraction (was Figma 1360px). */
export const DRAWER_FULL_WIDTH_VW = 0.97;

/** CSS length for the full-size drawer container. */
export const DRAWER_FULL_WIDTH_CSS = '97vw';

/** Figma drawer container minimum width. */
export const DRAWER_MIN_WIDTH = 400;

/** Resolve full drawer width to pixels for resize clamping / inline styles. */
export function getDrawerFullWidthPx(
  viewportWidth: number = typeof window !== 'undefined' ? window.innerWidth : 1400,
): number {
  return Math.round(viewportWidth * DRAWER_FULL_WIDTH_VW);
}

export const DRAWER_RESIZE_TOOLTIP = 'Resize drawer';

export type DrawerToolbarStepId =
  | 'model-configuration'
  | 'data-overview'
  | 'training'
  | 'evaluations';

/** Figma `.Drawer-tool-bar` multi-step navigation (`8052:11731`). */
export const DRAWER_TOOLBAR_STEPS: ReadonlyArray<{
  id: DrawerToolbarStepId;
  label: string;
  icon: string;
}> = [
  { id: 'model-configuration', label: 'Model Configuration', icon: 'model' },
  { id: 'data-overview', label: 'Data Editor', icon: 'graph' },
  { id: 'training', label: 'Training', icon: 'book' },
  { id: 'evaluations', label: 'Evaluations', icon: 'bar-chart-ascending' },
];

/** Default steps breadcrumb trail for drawer header stories (Figma `626:11569`). */
export const DEFAULT_DRAWER_STEPS_ITEMS: BreadcrumbItemData[] = [
  {
    label: 'Model Configuration',
    href: '#',
    icon: <SparkIcon slug="model" size="small" />,
  },
  {
    label: 'Data Overview',
    href: '#',
    icon: <SparkIcon slug="graph" size="small" />,
  },
  {
    label: 'Training',
    href: '#',
    icon: <SparkIcon slug="brain-icon" size="small" />,
  },
  { label: 'Evaluations', icon: <SparkIcon slug="bar-chart-ascending" size="small" /> },
];
